import Vue from 'vue'
import VueI18n from 'vue-i18n'
import locale from 'element-ui/lib/locale'
import elementEN from 'element-ui/lib/locale/lang/en' // element-ui 英文包
import elementZH from 'element-ui/lib/locale/lang/zh-CN' // element-ui 中文包
import elementES from 'element-ui/lib/locale/lang/es' // element-ui 西班牙语
import elementID from 'element-ui/lib/locale/lang/id' // element-ui 印尼语

import myZH from './zh'
import myEN from './en'
import myEs from './es'
import myId from './id'

Vue.use(VueI18n)

const i18n = new VueI18n({
  // 指定默认语言包
  locale: localStorage.getItem('language') || 'en',
  messages: {
    en: {
      ...elementEN,
      ...myEN
    },
    zh: {
      ...elementZH,
      ...myZH
    },
    es: {
      ...elementES,
      ...myEs
    },
    id: {
      ...elementID,
      ...myId
    }
  }
})

// 配置elementUI 语言转换关系
locale.i18n((key, value) => i18n.t(key, value))

export default i18n
